import {UI} from "../../../../stem-core/ui/UIBase.js";
import {registerStyle, styleRuleInherit} from "../../../../stem-core/ui/Style";
import {ConfirmationModal, ConfirmationModalStyle} from "../../../../blinkpay/ui/ConfirmationModal.jsx";
import {JourneySelectInput} from "../../../common/input/JourneySelectInput.jsx";


class AddJourneyToEntrypointModalStyle extends ConfirmationModalStyle {
    // Journey names and aliases together are much longer than the default dialog is wide.
    // Needs !important to beat BaseCard's own container rule, like ConfirmationModalStyle does for padding.
    @styleRuleInherit
    modal = {
        width: "720px !important",
        maxWidth: "calc(100vw - 48px) !important",
    };
}


interface AddJourneyToEntrypointModalOptions {
    availableJourneys?: any[];
}

@registerStyle(AddJourneyToEntrypointModalStyle)
export class AddJourneyToEntrypointModal extends ConfirmationModal<AddJourneyToEntrypointModalOptions> {
    declare journeySelect: JourneySelectInput;

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            confirmAction: () => this.resolve(this.journeySelect.getValue()),
        };
    }

    updateConfirmButton() {
        const disabled = !this.journeySelect.getValue();
        if (disabled !== this.confirmButtonDisabled) {
            this.confirmButtonDisabled = disabled;
            this.redraw();
        }
    }

    render() {
        return <JourneySelectInput ref="journeySelect"
                                   journeys={this.options.availableJourneys}
                                   onChange={() => this.updateConfirmButton()}/>;
    }

    onMount() {
        super.onMount();
        this.updateConfirmButton();
        this.journeySelect.focus();
    }
}